'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import { AnimatedD6 } from '@/components/market/position-card';
import { Skeleton } from '@/components/ui/app-skeleton';
import { DataTable } from '@/components/ui/data-table';
import { logger } from '@/lib/telemetry/logger';
import { type BackerRewardsPool, backerEarningsD6 } from './backer-earnings';
export function BackerEarningsCell(t0) {
  const $ = _c(17);
  const {
    sharesD6,
    claimedD6,
    snapshotD6: t1,
    pool,
    unavailable
  } = t0;
  const snapshotD6 = t1 === undefined ? null : t1;
  const t = useTranslations("market.backers");
  let t2;
  if ($[0] !== claimedD6 || $[1] !== pool || $[2] !== sharesD6) {
    t2 = pool === null ? null : backerEarningsD6(sharesD6, claimedD6, pool);
    $[0] = claimedD6;
    $[1] = pool;
    $[2] = sharesD6;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const liveD6 = t2;
  const earnedD6 = liveD6 ?? snapshotD6;
  const invalidSnapshot = pool !== null && liveD6 === null;
  let t3;
  let t4;
  if ($[4] !== invalidSnapshot) {
    t3 = () => {
      if (invalidSnapshot) {
        logger.warn("market_backers.invalid_earnings_snapshot", {});
      }
    };
    t4 = [invalidSnapshot];
    $[4] = invalidSnapshot;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== t) {
    t5 = t("column_earnings");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== earnedD6 || $[10] !== invalidSnapshot || $[11] !== t || $[12] !== unavailable) {
    t6 = <span data-testid="market-backer-earnings">{earnedD6 !== null ? <span className="text-data-profit"><AnimatedD6 d6={earnedD6} /></span> : unavailable || invalidSnapshot ? <span>{t("earnings_unavailable")}</span> : <Skeleton className="h-4 w-16" />}</span>;
    $[9] = earnedD6;
    $[10] = invalidSnapshot;
    $[11] = t;
    $[12] = unavailable;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <DataTable.TextCell align="right" mobileLabel={t5} className="max-xl:w-full">{t6}</DataTable.TextCell>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}